// extracted by mini-css-extract-plugin
export default {"clientPortalField":"ProjectNotesList_clientPortalField__4-qok"};